import { useState } from "react";
import Box from "@mui/material/Box";
import Nav from "./nav";
import Main from "./main";
import Header from "./header";

// ----------------------------------------------------------------------

export default function DashboardLayout({ children }: any) {
  const [openNav, setOpenNav] = useState(false);

  return (
    <Box sx={{ position: "relative", height: 1 }}>
      {/* Background Image with Opacity */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: "url(/assets/overlay1.jpeg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          opacity: 0.5,
          zIndex: -1,
        }}
      />

      {/* Content Section */}
      <Box
        sx={{
          position: "relative",
          backgroundColor: "rgba(255, 255, 255, 0.6)",
          height: 1,
        }}
      >
        <Header onOpenNav={() => setOpenNav(true)} />

        <Box
          sx={{
            minHeight: 1,
            display: "flex",
            flexDirection: { xs: "column", lg: "row" },
          }}
        >
          <Nav openNav={openNav} onCloseNav={() => setOpenNav(false)} />
          <Main>{children}</Main>
        </Box>
      </Box>
    </Box>
  );
}
